import {
  Box,
  Divider,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { useState } from "react";

function OrderParentComboProduct({
  divider,
  index,
  parentProduct,
  childProducts,
  comboAddons = [],
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <Box sx={{ mb: 3 }}>
      {/* Parent product row */}
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded((prev) => !prev)}
        sx={{
          boxShadow: "none",
          mb: 2,
          borderRadius: "14px",
          border: "1px solid rgba(183, 124, 10, 0.18)",
          background: "rgba(255,255,255,0.84)",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`combo-content-${index}`}
          id={`combo-header-${index}`}
          sx={{
            minHeight: 56,
            background: "transparent",
            borderRadius: 1,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{ width: "100%" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                width: "100%",
              }}
            >
              {/* ✅ Mobile only: Show product name as separate row */}
              <Box sx={{ display: { xs: "block", md: "none" } }}>
                <CakeName>{parentProduct?.product_name}</CakeName>
              </Box>

              {/* Main Row: Shown on all screens, includes image, name (for md+), tag, and price */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {/* Image */}
                <CartImage
                  src={parentProduct?.images?.[0]?.app_product_image}
                  alt={parentProduct?.product_name}
                />

                {/* Name & Tags */}
                <Box sx={{ flexGrow: 1, alignSelf: "flex-start" }}>
                  {/* ✅ Hidden on xs, shown on md+ */}
                  <CakeName sx={{ display: { xs: "none", md: "block" } }}>
                    {parentProduct?.product_name}
                  </CakeName>

                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ mt: 1 }}
                  >
                    <ComboTag />

                    {/* ✅ Show price on desktop only (near ComboTag) */}
                    <Typography
                      variant="h5"
                      sx={{
                        display: { xs: "none", md: "block" },
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "150%",
                        color: "var(--neutral-black)",
                        textAlign: "right",
                      }}
                    >
                      ₹{" "}
                      {+parentProduct?.combo_price *
                        +parentProduct?.product_quantity}
                    </Typography>
                  </Stack>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "var(--neutral-800)",
                      marginTop: 1,
                    }}
                  >
                    Qty {parentProduct?.product_quantity}
                  </Typography>
                  {/* ✅ Show price on mobile only (normal position below ComboTag) */}
                  <Typography
                    variant="h5"
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontWeight: 600,
                      fontSize: "16px",
                      lineHeight: "150%",
                      color: "var(--neutral-black)",
                      mt: 1,
                      textAlign: "left",
                    }}
                  >
                    ₹{" "}
                    {+parentProduct?.combo_price *
                      +parentProduct?.product_quantity}
                  </Typography>
                </Box>

                {/* Price */}
                {/* <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    lineHeight: "150%",
                    color: "var(--neutral-black)",
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  ₹{" "}
                  {+parentProduct?.combo_price *
                    +parentProduct?.product_quantity}
                </Typography> */}
              </Box>
            </Box>
          </Stack>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            background: "rgba(255,255,255,0.65)",
            gap: 2,
            display: "flex",
            flexWrap: "wrap",
            p: { xs: 0, md: 2 },
          }}
        >
          {/* Child products as two full rows */}
           {childProducts.map((item, idx) => {
            const childPrice =
              item.variation?.egg > 0
                ? item.variation?.egg
                : item.variation?.eggLess;

            // ✅ Fixed: use variation.weight[0] same as OrderProductItem
            const weightInfo = item?.variation?.weight?.[0];
            const weightLabel = weightInfo
              ? `${weightInfo.weight_name} ${weightInfo.unit?.unit_name}`
              : "-";

            return (
              <Box
                key={item?.order_product_id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  borderRadius: "12px",
                  background: "rgba(255, 247, 232, 0.72)",
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "100%",
                    lg: "48%",
                  },
                  border: "1px solid rgba(183, 124, 10, 0.16)",
                  py: 1,
                  px: {
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
              >
                {/* Show product name ABOVE image ONLY on small screens (<370px) */}
                <CakeName
                  sx={{
                    display: "none",
                    "@media (max-width:369px)": {
                      display: "block",
                    },
                    fontSize: "14px",
                    fontWeight: 500,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {item?.product_details?.[0]?.product_name}
                </CakeName>

                {/* Main content row (image + details) */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <CartImage
                    src={
                      item?.product_details?.[0]?.images?.[0]?.app_product_image
                    }
                    alt={item?.product_details?.[0]?.product_name}
                    style={{ width: 50, height: 50 }}
                  />

                  <Box sx={{ flexGrow: 1 }}>
                    <CakeName
                      sx={{
                        display: "none",
                        "@media (min-width:370px)": {
                          display: "block",
                        },
                        fontSize: "14px",
                        fontWeight: 500,
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {item?.product_details?.[0]?.product_name}
                    </CakeName>

                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ mt: 0.5 }}
                    >
                      {/* ✅ Fixed weight */}
                      <Typography
                        variant="body2"
                        sx={{ color: "var(--neutral-500)", fontSize: "12px" }}
                      >
                        {weightLabel}
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "var(--neutral-black)",
                          fontSize: "14px",
                          textAlign: "right",
                        }}
                      >
                        ₹ {childPrice}
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
              </Box>
            );
          })}
          {comboAddons.map((addon, idx) => (
            <Box
              key={`addon-${idx}`}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                borderRadius: "12px",
                background: "rgba(255, 247, 232, 0.72)",
                width: { xs: "100%", sm: "100%", md: "100%", lg: "48%" },
                border: "1px solid rgba(183, 124, 10, 0.16)",
                py: 1,
                px: { xs: 1, sm: 2, md: 2, lg: 2 },
              }}
            >
              <CartImage src={addon?.image} alt={addon?.product_name} style={{ width: 50, height: 50 }} />
              <Box sx={{ flexGrow: 1 }}>
                <CakeName
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    whiteSpace: "normal",
                  }}
                >
                  {addon?.product_name}
                </CakeName>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 0.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "var(--neutral-500)", fontSize: "12px" }}
                  >
                    Add-on
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "var(--neutral-black)",
                      fontSize: "14px",
                    }}
                  >
                    ₹ {addon?.price}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>
      {divider && <Divider variant="middle" sx={{ my: 1 }} />}
    </Box>
  );
}

const CartImage = styled("img")(({ theme }) => ({
  backgroundColor: "#f8f8f8",
  textAlign: "center",
  width: "64px",
  height: "64px",
  borderRadius: "12px",
  cursor: "pointer",
  objectFit: "cover",
  [theme.breakpoints.down("sm")]: {
    width: "64px !important",
    height: "64px !important",
  },
}));
const ComboTag = () => {
  const StyledComboTag = styled("span")(({ theme }) => ({
    backgroundColor: "rgba(210, 74, 38, 0.12)",
    color: "#9B3119",
    fontWeight: "bold",
    fontSize: "0.75rem",
    padding: "0.2rem 0.5rem",
    borderRadius: "999px",
    marginLeft: "8px",
    border: "1px solid rgba(210, 74, 38, 0.18)",
    display: "inline-block",
    userSelect: "none",
  }));

  return <StyledComboTag>COMBO</StyledComboTag>;
};
const CakeName = styled("h3")(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "150%",
  color: "#2C2418",
  textAlign: "left",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  [theme.breakpoints.down("sm")]: {
    fontSize: "15px !important",
  },
}));
export default OrderParentComboProduct;
